module.exports = __webpack_public_path__ + "img/sendDoc.e619a80e.svg";